import uuid from "uuid";
import moment from "moment";
import {MARK_UP_APPLY_TO_TYPES} from "./markUpItemInterface";
import {setFeaturePriceFromMarkItem} from "../featuresActions";
import {percentage} from "../../../misc";
// import {defaultMarkUpItem} from "./markUpItemInterface";

export const createNewMarkUpItem = (applyToValue, type, priceType, value) => {
  return {
    id: uuid.v4(),
    type,
    priceType,
    applyTo: applyToValue,
    value,
    created: moment().unix(),
    updated: null,
  }
}

export const createMarkUpList = (features) => {
  let markUpList = [];
  features.forEach((feature) => {
    if (!feature.markUpLogic) {
      return false
    }
    const parsed = JSON.parse(feature.markUpLogic);
    // console.log("parsed", parsed);
    if (!Array.isArray(parsed)) {
      return false
    }
    parsed.forEach(markUpListItem => {
      if (feature.unlinkedData && (markUpListItem.forUnlinkedCatId !== +feature.unlinkedData.featureGroupCategory_id)) {
        return
      }
      if (!markUpList.some(markUpItem => markUpItem.id === markUpListItem.id)) {
        markUpList.push(markUpListItem)
      }
    })
  })
  console.log("markUpList", markUpList);
  return markUpList
}

export const getParsedMarkUpLogic = (feature) => {
  if (!feature.markUpLogic) {
    return null
  }
  const parsed = JSON.parse(feature.markUpLogic);
  return Array.isArray(parsed) ? parsed : null
}

export const getSameApplyTo = (applyTo, applyTo2) => {
  switch (applyTo) {
    case MARK_UP_APPLY_TO_TYPES.retailPrice:
      return applyTo2 === MARK_UP_APPLY_TO_TYPES.retailPrice || applyTo2 === MARK_UP_APPLY_TO_TYPES.retailPriceAndCost
    case MARK_UP_APPLY_TO_TYPES.cost:
      return applyTo2 === MARK_UP_APPLY_TO_TYPES.cost || applyTo2 === MARK_UP_APPLY_TO_TYPES.retailPriceAndCost
    case MARK_UP_APPLY_TO_TYPES.retailPriceAndCost:
      return applyTo2 === MARK_UP_APPLY_TO_TYPES.retailPrice
        || applyTo2 === MARK_UP_APPLY_TO_TYPES.retailPriceAndCost
        || applyTo2 === MARK_UP_APPLY_TO_TYPES.cost
    case MARK_UP_APPLY_TO_TYPES.shippingCost:
      return applyTo2 === MARK_UP_APPLY_TO_TYPES.shippingCost
  }
  return false
}

export const getRevertedPriceAndCost = (applyTo) => {
  return applyTo === MARK_UP_APPLY_TO_TYPES.cost
    ? MARK_UP_APPLY_TO_TYPES.retailPrice
    : applyTo === MARK_UP_APPLY_TO_TYPES.retailPrice ? MARK_UP_APPLY_TO_TYPES.cost : applyTo
}

export const applyFeatureMarkUp = (dbFeature) => {
  const parsedMarkUp = JSON.parse(dbFeature.markUpLogic);
  if (Array.isArray(parsedMarkUp)) {
    parsedMarkUp.forEach(markUpListItem => {
      // console.log("dbFeature price cost", dbFeature.price, dbFeature.cost);
      dbFeature = setFeaturePriceFromMarkItem(markUpListItem, dbFeature, !!dbFeature.unlinkedData);
      // console.log("dbFeature price cost", dbFeature.price, dbFeature.cost);
    })
  } else if (typeof parsedMarkUp === "object" && (parsedMarkUp !== null)) {
    console.log("", parsedMarkUp);
    // CAES format!!
    // {
    //   Cost: {Type: 'MarkDown', Value: 10}
    //   Discount : {Type: 'MarkDown', Value: 0}
    //   Retail : {Type: 'MarkDown', Value: 10}
    // }
    dbFeature = setFeaturePriceFromMarkObject(parsedMarkUp, dbFeature)
  }
  return dbFeature
}

const CS_MARK_UP_PROPS_MATCH = {
  Retail: "price",
  Cost: "cost",
  Discount: "fabricatorCost",
};

const getUpdatedFeaturePriceFromMarkItem = (markUpListItem, originalValue) => {
  const {Type, PriceType, Value} = markUpListItem;
  const changeValue = (PriceType === "currency")
    ? +Value
    : percentage(+originalValue, +Value);
  let newValue = (Type === "mark_up" || Type === "MarkUp")
    ? +originalValue + changeValue
    : +originalValue - changeValue;
  return newValue < 0 ? 0 : +(newValue.toFixed(2));
}

/**
 * @param markUpObject {object}
 * @param dbFeature {object}
 * @return {object}
 */
const setFeaturePriceFromMarkObject = (markUpObject, dbFeature) => {
  if (!dbFeature || !markUpObject) {
    return dbFeature
  }
  // console.log("markUpObject", dbFeature.price, dbFeature.cost);
  Object.keys(markUpObject).forEach(key => {
    if (!markUpObject[key].Value || !CS_MARK_UP_PROPS_MATCH[key]) {
      return
    }
    dbFeature[CS_MARK_UP_PROPS_MATCH[key]] = getUpdatedFeaturePriceFromMarkItem(markUpObject[key], dbFeature[CS_MARK_UP_PROPS_MATCH[key]]);
  });
  // console.log("markUpObject after", dbFeature.price, dbFeature.cost);
  return dbFeature
}
